import React, { FC, ReactElement } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import type { XHComponentCommonProps } from "../../../types";

import { StepProps } from "..";

const classPrefix = `xh-steps`;
const stepClassPrefix = `xh-step`;

const defaultIcon = <span className={`${stepClassPrefix}-icon-dot`} />;

export type StepsProps = {
  current?: number;
  direction?: "horizontal" | "vertical";
  children?: React.ReactNode;
  style?: React.CSSProperties & {
    "--line-to-next-color"?: string;
    "--color-primary"?: string;
  };
  dashed?: boolean;
} & XHComponentCommonProps;

const Steps: FC<StepsProps> = props => {
  const {
    direction = "horizontal",
    current = 0,
    style,
    className,
    dashed = false,
  } = props;
  const classString = classNames(
    classPrefix,
    `${classPrefix}-${direction}`,
    className
  );

  return (
    <View className={classString} style={style}>
      {React.Children.map(
        props.children,
        (child: ReactElement<StepProps>, index) => {
          if (!React.isValidElement(child)) {
            return child;
          }
          const props = child.props;

          let status = props.status || "wait";
          if (index < current) {
            status = props.status || "finish";
          } else if (index === current) {
            status = props.status || "process";
          }

          const icon = props.icon ?? defaultIcon;

          return React.cloneElement(child, {
            status,
            icon,
            direction,
            dashed,
          });
        }
      )}
    </View>
  );
};

export default Steps;
